<template>
  <div class="coupon-list-container">
    <el-card class="header-card">
      <div class="header-content">
        <h2>卡券管理</h2>
        <div class="header-right">
          <el-button type="primary" size="small" @click="handleAdd"><i class="el-icon-plus"></i> 创建卡券</el-button>
          <el-button size="small" @click="refreshData"><i class="el-icon-refresh"></i> 刷新</el-button>
        </div>
      </div>
    </el-card>

    <div v-loading="loading" class="coupon-grid">
      <el-empty v-if="list.length === 0" description="暂无卡券" />
      <div v-for="item in list" :key="item.id" class="coupon-card">
        <div class="card-image-box">
          <el-image v-if="item.image" :src="item.image" fit="cover" class="card-image" />
          <div v-else class="card-image-placeholder"><i class="el-icon-picture-outline"></i></div>
        </div>

        <div class="card-header">
          <span class="card-title">{{ item.name }}</span>
          <el-tag v-if="item.tag" size="mini" type="danger">{{ item.tag }}</el-tag>
          <el-switch v-model="item.status" :active-value="1" :inactive-value="0" @change="(val) => handleToggleStatus(item, val)" class="status-switch" />
        </div>

        <div class="card-body">
          <div class="price-row">
            <span class="price">¥{{ formatPrice(item.price) }}</span>
            <span class="original-price">¥{{ formatPrice(item.originalPrice) }}</span>
          </div>
          <div class="info-row">
            <span>库存：{{ item.stock }}</span>
            <span>已售：{{ item.salesCount }}</span>
          </div>
          <div class="info-row">
            <span>有效期：{{ item.voucherValidDays }}天</span>
            <span>{{ item.canRefund ? '支持退款' : '不支持退款' }}</span>
          </div>
          <div class="desc-text" :title="item.description">{{ item.description }}</div>
          <div class="product-tags" v-if="item.products && item.products.length">
            <span class="product-tag" v-for="p in item.products.slice(0, 3)" :key="p.productId">{{ p.productName }} x{{ p.productCount }}</span>
            <el-button v-if="item.products.length > 3" type="text" size="mini" @click="handleView(item)">等{{ item.products.length }}件商品</el-button>
          </div>
        </div>

        <div class="card-footer">
          <el-button type="text" size="small" @click="handleView(item)">详情</el-button>
          <el-button type="text" size="small" @click="handleEdit(item)">编辑</el-button>
          <el-button type="text" size="small" style="color:#F56C6C" @click="handleDelete(item)">删除</el-button>
        </div>
      </div>
    </div>

    <div class="pagination-container">
      <el-pagination :current-page="pagination.currentPage" :page-sizes="[12,24,48]" :page-size="pagination.pageSize" :total="pagination.total" layout="total, sizes, prev, pager, next" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </div>

    <el-dialog title="卡券详情" :visible.sync="detailVisible" width="550px" append-to-body destroy-on-close>
      <div v-if="current.id">
        <div class="detail-image" v-if="current.image">
          <el-image :src="current.image" fit="cover" style="width:100%;max-height:260px;border-radius:8px;" />
        </div>
        <el-descriptions :column="2" border size="small" style="margin-top:16px;">
          <el-descriptions-item label="名称">{{ current.name }}</el-descriptions-item>
          <el-descriptions-item label="标签"><el-tag v-if="current.tag" size="mini" type="danger">{{ current.tag }}</el-tag></el-descriptions-item>
          <el-descriptions-item label="售价">¥{{ formatPrice(current.price) }}</el-descriptions-item>
          <el-descriptions-item label="原价">¥{{ formatPrice(current.originalPrice) }}</el-descriptions-item>
          <el-descriptions-item label="库存">{{ current.stock }}</el-descriptions-item>
          <el-descriptions-item label="销量">{{ current.salesCount }}</el-descriptions-item>
          <el-descriptions-item label="券有效期">{{ current.voucherValidDays }}天</el-descriptions-item>
          <el-descriptions-item label="退款">{{ current.canRefund ? '支持' : '不支持' }}（{{ current.refundDeadline }}天）</el-descriptions-item>
          <el-descriptions-item label="描述" :span="2">{{ current.description || '-' }}</el-descriptions-item>
        </el-descriptions>
        <div class="section-title">包含商品</div>
        <div class="product-tags">
          <span class="product-tag" v-for="p in current.products" :key="p.productId">{{ p.productName }} x{{ p.productCount }}</span>
        </div>
      </div>
      <span slot="footer"><el-button @click="detailVisible = false">关闭</el-button></span>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/utils/api"

export default {
  name: 'CouponList',
  data() {
    return {
      loading: false, list: [],
      pagination: { currentPage: 1, pageSize: 10, total: 0 },
      detailVisible: false, current: {}
    }
  },
  mounted() { this.loadList() },
  methods: {
    async loadList() {
      this.loading = true
      try {
        const res = await api.product_getCombinationList({ page: this.pagination.currentPage, pageSize: this.pagination.pageSize }, null)
        const d = res.data || res
        if (d.code === '000') {
          this.list = d.data.list || d.data.records || d.data || []
          this.pagination.total = d.data.total || d.data.totalCount || this.list.length
        }
      } catch (e) { this.$message.error('加载失败') }
      finally { this.loading = false }
    },
    formatPrice(p) { return p ? (p / 100).toFixed(2) : '0.00' },
    handleView(row) { this.current = row; this.detailVisible = true },
    handleEdit(row) { this.$router.push({ path: '/Index/Product/CouponEdit', query: { id: row.id } }) },
    handleAdd() { this.$router.push('/Index/Product/CouponAdd') },
    async handleToggleStatus(row, val) {
      try { const res = await api.product_updateProduct({ id: row.id, status: val }, { contentType: 'json' }); if ((res.data || res).code !== '000') row.status = val === 1 ? 0 : 1 } catch (e) { row.status = val === 1 ? 0 : 1 }
    },
    async handleDelete(row) {
      try { await this.$confirm('确定删除？', '提示', { type: 'warning' }); const res = await api.product_deleteCombination({ id: row.id }, null); if ((res.data || res).code === '000') { this.$message.success('删除成功'); this.loadList() } } catch (e) {}
    },
    handleSizeChange(s) { this.pagination.pageSize = s; this.pagination.currentPage = 1; this.loadList() },
    handleCurrentChange(p) { this.pagination.currentPage = p; this.loadList() },
    refreshData() { this.pagination.currentPage = 1; this.loadList() }
  }
}
</script>

<style scoped lang="scss">
.coupon-list-container { padding: 20px; }
.header-card { margin-bottom: 20px; .header-content { display: flex; justify-content: space-between; align-items: center; h2 { margin: 0; font-size: 20px; } .header-right { display: flex; gap: 8px; } } }
.coupon-grid { display: grid; grid-template-columns: repeat(5, 1fr); gap: 16px; min-height: 200px; @media (max-width: 1600px) { grid-template-columns: repeat(4, 1fr); } @media (max-width: 1200px) { grid-template-columns: repeat(3, 1fr); } @media (max-width: 900px) { grid-template-columns: repeat(2, 1fr); } @media (max-width: 600px) { grid-template-columns: 1fr; } }
.coupon-card {
  background: #fff; border: 1px solid #ebeef5; border-radius: 12px; overflow: hidden;
  display: flex; flex-direction: column; transition: box-shadow 0.2s;
  &:hover { box-shadow: 0 4px 16px rgba(0,0,0,0.08); }
  .card-image-box { .card-image { width: 100%; height: 140px; display: block; } .card-image-placeholder { width: 100%; height: 140px; background: #f5f7fa; display: flex; align-items: center; justify-content: center; color: #c0c4cc; font-size: 32px; } }
  .card-header { display: flex; align-items: center; gap: 8px; padding: 12px 14px 0; .card-title { font-size: 14px; font-weight: 600; color: #303133; flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; } .status-switch { flex-shrink: 0; } }
  .card-body { padding: 6px 14px; flex: 1; .price-row { display: flex; align-items: baseline; gap: 8px; margin-bottom: 4px; .price { font-size: 18px; font-weight: bold; color: #f56c6c; } .original-price { font-size: 11px; color: #c0c4cc; text-decoration: line-through; } } .info-row { display: flex; gap: 12px; font-size: 11px; color: #909399; margin-bottom: 2px; } .desc-text { font-size: 11px; color: #606266; margin-top: 4px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; } .product-tags { display: flex; flex-wrap: wrap; gap: 3px; margin-top: 6px; } .product-tag { background: #f0f9eb; color: #67c23a; padding: 1px 6px; border-radius: 3px; font-size: 10px; } }
  .card-footer { display: flex; gap: 6px; padding: 8px 14px 12px; border-top: 1px solid #f0f0f0; }
}
.pagination-container { display: flex; justify-content: flex-end; margin-top: 20px; }
.section-title { font-size: 14px; font-weight: 600; color: #303133; margin: 16px 0 8px; }
.product-tags { display: flex; flex-wrap: wrap; gap: 6px; }
.product-tag { background: #f0f9eb; color: #67c23a; padding: 4px 10px; border-radius: 4px; font-size: 12px; }
.detail-image { text-align: center; }
</style>